module.exports = __webpack_public_path__ + "static/img/btn_Steam.f4ca3b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/btn_Steam.png
// module id = z6DH
// module chunks = 0